import { useEffect, useState } from "react";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import Banner from "../../components/search/banner";
import MachineList from "../../components/search/machineList";
import FilterSidebar from "../../components/search/silterSidebar";
import { ApplicationId } from "../../api/url";
import { postMachinesList } from "../../services/FeaturedListings";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../../components/admin/layouts/PageWrapper/PageWrapper";
import InfiniteScroll from "react-infinite-scroll-component";
import CardSkeleton from "../../components/loader/skeleton/cardSkeleton";

const Search = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLazyLoading, setIsLazyLoading] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isMachineData, setIsMachineData] = useState([]);
  const [additionalFilters, setAdditionalFilters] = useState({
    PageSize: 9,
    PageNumber: 1,
    Categorys: [],
    Makes: [],
    Keywords: null,
    Models: [],
    MinYear: null,
    MaxYear: null,
    MinHours: null,
    MaxHours: null,
    MinPrice: null,
    MaxPrice: null,
  });

  // Sync filters from state
  useEffect(() => {
    const updatedFilters = { ...additionalFilters };

    if (state?.selectCategory) {
      updatedFilters.Categorys = JSON.parse(state.selectCategory);
    }

    if (state?.selectMake) {
      updatedFilters.Makes = JSON.parse(state.selectMake);
    }
    if (state?.selectModel) {
      updatedFilters.Models = JSON.parse(state.selectModel);
    }

    if (state?.MinYear) {
      updatedFilters.MinYear = state.MinYear;
    }

    if (state?.MaxYear) {
      updatedFilters.MaxYear = state.MaxYear;
    }

    if (state?.MinYear) {
      updatedFilters.MinYear = state.MinYear;
    }

    if (state?.MinHours) {
      updatedFilters.MinHours = state.MinHours;
    }

    if (state?.MaxHours) {
      updatedFilters.MaxHours = state.MaxHours;
    }

    if (state?.MinPrice) {
      updatedFilters.MinPrice = state.MinPrice;
    }

    if (state?.MaxPrice) {
      updatedFilters.MaxPrice = state.MaxPrice;
    }

    setAdditionalFilters(updatedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state?.selectCategory,
    state?.selectMake,
    state?.keywords,
    state?.selectModel,
    state?.MaxYear,
    state?.MinYear,
    state?.MinHours,
    state?.MaxHours,
    state?.MinPrice,
    state?.MaxPrice,
  ]);

  // Fetch machine list whenever filters change
  useEffect(() => {
    if (!isLoading) {
      GetMachinesList(additionalFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    additionalFilters.PageNumber,
    additionalFilters.Categorys.length,
    additionalFilters.Makes.length,
    additionalFilters.Models.length,
    additionalFilters.MinYear,
    additionalFilters.MaxYear,
    additionalFilters.MinPrice,
    additionalFilters.MaxPrice,
    additionalFilters.MinHours,
    additionalFilters.MaxHours,
  ]);

  const GetMachinesList = (Filters) => {
    if (parseInt(Filters?.PageNumber) === 1) {
      setIsLoading(true);
    } else {
      setIsLazyLoading(true);
    }
    let payload = {
      PageNumber: Filters?.PageNumber,
      PageSize: Filters?.PageSize,
      ApplicationId: ApplicationId,
      SearchKey: state?.keywords || "",
      categoryIds: state?.selectCategory
        ? JSON.parse(state?.selectCategory)?.map((item) => item.CategoryId)
        : [],
      makeIds: state?.selectMake
        ? JSON.parse(state?.selectMake)?.map((item) => item.MakeId)
        : [],
      models: state?.selectModel ? JSON.parse(state?.selectModel) : [],
    };

    if (Filters.MaxYear) {
      payload = {
        ...payload,
        MaxYear: Number(Filters.MaxYear),
      };
    }
    if (Filters.MinYear) {
      payload = {
        ...payload,
        MinYear: Number(Filters.MinYear),
      };
    }

    if (Filters.MaxPrice) {
      payload = {
        ...payload,
        MaxPrice: Number(Filters.MaxPrice),
      };
    }
    if (Filters.MinPrice) {
      payload = {
        ...payload,
        MinPrice: Number(Filters.MinPrice),
      };
    }
    if (Filters.MaxHours) {
      payload = {
        ...payload,
        MaxHours: Number(Filters.MaxHours),
      };
    }
    if (Filters.MinHours) {
      payload = {
        ...payload,
        MinHours: Number(Filters.MinHours),
      };
    }
    postMachinesList(payload)
      .then((res) => {
        const showImgList = res?.data?.machines?.map((item) => ({
          ...item,
          image: item?.primary_image?.url,
          caption: `<div class="bg-[#000] responsive_text_field" style="background: rgba(0,0,0,0.5); width: 90%; margin: auto; text-align:right; padding:0px 10px ">
                    ${item?.year}&nbsp;&nbsp;&nbsp;${item?.model?.number}&nbsp;&nbsp;&nbsp;${item?.model?.manufacturer?.name} -  Click for Details
                  </div>`,
          assetAdvertisementId: item?.assetAdvertisementId,
          name: item?.primary_image?.name.replaceAll(" ", "-"),
        }));

        setTotalRecords(res?.data?.TotalRecords || 0);
        setMachineData(showImgList || []);

        setIsLazyLoading(false);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
        setIsLazyLoading(false);
      });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document
      .querySelector(".custom-container")
      ?.scrollTo({ top: 0, behavior: "smooth" });
  }, [additionalFilters.PageNumber]);

  // Remove keywords
  const handleRemoveKeyword = () => {
    const newState = { ...state, keywords: "" };
    navigate(".", { state: newState, replace: true });

    setAdditionalFilters((prev) => ({
      ...prev,
      Keywords: "",
      PageNumber: 1,
    }));
  };

  // Remove a category by ID
  const handleRemoveCategory = (ID) => {
    const updatedCategories = additionalFilters.Categorys.filter(
      (item) => item.CategoryId !== ID
    );

    const newState = {
      ...state,
      selectCategory: updatedCategories.length
        ? JSON.stringify(updatedCategories)
        : "",
    };
    navigate(".", { state: newState, replace: true });

    setAdditionalFilters((prev) => ({
      ...prev,
      Categorys: updatedCategories,
      PageNumber: 1,
    }));
  };

  // Remove a make by ID
  const handleRemoveMake = (ID) => {
    const updatedMakes = additionalFilters.Makes.filter(
      (item) => item.MakeId !== ID
    );

    const newState = {
      ...state,
      selectMake: updatedMakes.length ? JSON.stringify(updatedMakes) : "",
    };
    navigate(".", { state: newState, replace: true });

    setAdditionalFilters((prev) => ({
      ...prev,
      Makes: updatedMakes,
      PageNumber: 1,
    }));
  };

  // Remove a Model by ID
  const handleRemoveModel = (ID) => {
    const updatedModels = additionalFilters.Models.filter(
      (item) => item !== ID
    );

    const newState = {
      ...state,
      selectModel: updatedModels.length ? JSON.stringify(updatedModels) : "",
    };
    navigate(".", { state: newState, replace: true });

    setAdditionalFilters((prev) => ({
      ...prev,
      Models: updatedModels,
      PageNumber: 1,
    }));
  };

  // Add filters for category and make

  const handleAddFilter = (
    selectedTempCategory,
    selectedTempMake,
    selectedTempModel,
    selectedTempMaxYear,
    selectedTempMinYear,
    selectedTempMaxHours,
    selectedTempMinHours,
    selectedTempMaxPrice,
    selectedTempMinPrice
  ) => {
    const newState = {
      ...state,
      selectCategory: selectedTempCategory
        ? JSON.stringify(selectedTempCategory)
        : "",
      selectMake: selectedTempMake ? JSON.stringify(selectedTempMake) : "",
      selectModel: selectedTempModel ? JSON.stringify(selectedTempModel) : "",
      MaxYear: selectedTempMaxYear,
      MinYear: selectedTempMinYear,
      MinHours: selectedTempMinHours,
      MaxHours: selectedTempMaxHours,
      MinPrice: selectedTempMinPrice,
      MaxPrice: selectedTempMaxPrice,
    };
    navigate(".", { state: newState, replace: true });
    setAdditionalFilters((prev) => ({
      ...prev,
      Categorys: selectedTempCategory || [],
      Makes: selectedTempMake || [],
      Models: selectedTempModel || [],
      MaxYear: selectedTempMaxYear,
      MinYear: selectedTempMinYear,
      MinHours: selectedTempMinHours,
      MaxHours: selectedTempMaxHours,
      MinPrice: selectedTempMinPrice,
      MaxPrice: selectedTempMaxPrice,
      PageNumber: 1,
    }));
  };
  return (
    <>
      <PageWrapper name="Mchine List">
        <Header />
        <Banner path={""} />
        <div className="custom-container">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-[20px] mb-[30px]">
            <div className="col-span-1 md:col-span-1">
              <FilterSidebar
                selectedCategory={additionalFilters.Categorys}
                selectedMake={additionalFilters.Makes}
                selectedModel={additionalFilters.Models}
                selectedMaxYear={additionalFilters.MaxYear}
                selectedMinYear={additionalFilters.MinYear}
                selectedMinHours={additionalFilters.MinHours}
                selectedMaxHours={additionalFilters.MaxHours}
                selectedMinPrice={additionalFilters.MinPrice}
                selectedMaxPrice={additionalFilters.MaxPrice}
                handelAddFilter={handleAddFilter}
                onCloseFilter={() => {
                  setAdditionalFilters((prev) => ({
                    ...prev,
                    PageNumber: 1,
                  }));
                }}
              />
            </div>
            <div className="col-span-1 md:col-span-3">
              <div className="flex flex-wrap flex-row">
                {state?.keywords && (
                  <div className="mb-[14px] bg-[#FEBA06] rounded-[6px] py-[7px] px-[13px] text-[#FFFFFF] font-bold text-[11px] mr-[10px]">
                    <span
                      className="cursor-pointer"
                      onClick={() => handleRemoveKeyword()}
                    >
                      x
                    </span>{" "}
                    {state?.keywords}
                  </div>
                )}

                {additionalFilters.Categorys?.length > 0 &&
                  additionalFilters.Categorys.map((item) => (
                    <div
                      key={item?.CategoryId}
                      className="mb-[14px] bg-[#FEBA06] rounded-[6px] py-[7px] px-[13px] text-[#FFFFFF] font-bold text-[11px] mr-[10px]"
                    >
                      <span
                        className="cursor-pointer"
                        onClick={() => handleRemoveCategory(item?.CategoryId)}
                      >
                        x
                      </span>{" "}
                      {item?.CategoryName}
                    </div>
                  ))}

                {additionalFilters?.Makes?.length > 0 &&
                  additionalFilters?.Makes.map((item) => (
                    <div
                      key={item?.MakeId}
                      className="mb-[14px] bg-[#FEBA06] rounded-[6px] py-[7px] px-[13px] text-[#FFFFFF] font-bold text-[11px] mr-[10px]"
                    >
                      <span
                        className="cursor-pointer"
                        onClick={() => handleRemoveMake(item?.MakeId)}
                      >
                        x
                      </span>{" "}
                      {item?.MakeName}
                    </div>
                  ))}

                {additionalFilters?.Models?.length > 0 &&
                  additionalFilters?.Models.map((item) => (
                    <div
                      key={item}
                      className="mb-[14px] bg-[#FEBA06] rounded-[6px] py-[7px] px-[13px] text-[#FFFFFF] font-bold text-[11px] mr-[10px]"
                    >
                      <span
                        className="cursor-pointer"
                        onClick={() => handleRemoveModel(item)}
                      >
                        x
                      </span>{" "}
                      {item}
                    </div>
                  ))}
              </div>

              {/* ✅ REMOVED: InfiniteScroll - Use Pagination Instead */}
              <MachineList
                isLoading={isLoading}
                machineData={machineData}
                totalRecords={totalRecords}
                showRecord={additionalFilters.PageSize}
                currentPage={additionalFilters.PageNumber}
                setCurrentPage={(value) => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setAdditionalFilters((prev) => ({
                    ...prev,
                    PageNumber: value,
                  }));
                }}
                isSearch={true}
              />

              {isLazyLoading && (
                <div className="grid grid-cols-3 gap-6 max-[842px]:grid-cols-1 mt-[30px]">
                  {[1, 2, 3].map((i) => (
                    <CardSkeleton key={i} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </PageWrapper>
    </>
  );
};
export default Search;
